import type { IEllipsisDropdownItemProps } from "@similarweb/ui-components";
import type { UnknownProps } from "app/pages/sales-intelligence/types";
import type { ComponentType, ReactNode } from "react";
import FilterDropdownItemWithCheckbox from "../FilterDropdownItemWithCheckbox/FilterDropdownItemWithCheckbox";

type Props = IEllipsisDropdownItemProps & {
    as?: ComponentType<UnknownProps>;
    children: ReactNode;
};

const FilterSelectAllItem = ({ as: Element = FilterDropdownItemWithCheckbox, children, ...itemProps }: Props) => {
    return (
        <Element
            {...itemProps}
            isPrimary
        >
            {children}
        </Element>
    );
};

export default FilterSelectAllItem;
